import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { faDownload, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FileType } from "../../../enum/file-type.enum";
import { FileUpload } from "../../../model/domain/File";
import { PagedList } from "../../../model/domain/PagedList";
import { ReviewersDecisionModel } from "../../../model/domain/ReviewersDecisionModel";
import { StructuredOperationPrecedentModel } from "../../../model/domain/StructuredOperationPrecedentModel";
import { AuthService } from "../../../services/auth.service";
import { DialogService } from "../../../services/dialog.service";
import { DownloadService } from "../../../services/download.service";
import { FileService } from "../../../services/file.service";
import { LoaderService } from "../../../services/loader.service";
import { SnackbarService } from "../../../services/snackbar.service";
import { TicketService } from "../../../services/ticket.service";

@Component({
  selector: "app-operation-structured-reservation-dialog",
  templateUrl: "./operation-structured-precedent-dialog.component.html",
  styleUrls: ["./operation-structured-precedent-dialog.component.css"],
})
export class OperationStructuredPrecedentDialogComponent {
  model: StructuredOperationPrecedentModel;
  reviewersList: ReviewersDecisionModel[];
  Files: FileUpload[] = [];
  defaultPage = 1;
  defaultPageSize = 10;
  uploadPageSize: number = this.defaultPageSize;
  uploadTotalPages: number = null;
  uploadTotalItems: number = null;
  uploadListedPages: any[];
  uploadFirstItemOnPage: number;
  uploadLastItemOnPage: number;
  uploadCurrentPage: number = this.defaultPage;
  roles: number[] = [];
  canDelete: any[] = [];

  faEye = faEye;
  faDownload = faDownload;
  faTrash = faTrash;

  ColumnsFile: string[] = ["name", "createDate", "createUser", "actions"];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private fileService: FileService,
    private authService: AuthService,
    private service: TicketService,
    private downloadService: DownloadService,
    private loaderService: LoaderService,
    private snackBarService: SnackbarService,
    private dialogService: DialogService
  ) {
    this.model = data.model;
    this.reviewersList = data.reviewersList;
    this.loadFilesPaged();
  }

  loadFilesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = [];

    if (page) {
      params.push(page);
    } else {
      params.push(this.uploadCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.uploadPageSize = pageSize;
    } else if (this.uploadPageSize) {
      params.push(this.uploadPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.fileService
      .getFilesPaginatedAttachment(
        null,
        this.model.ticketId,
        FileType.PrecedentFile,
        page,
        pageSize,
        null,
        this.model.id
      )
      .subscribe((files) => {
        if (files) {
          this.Files = files.results;
          this.renderPaginatorFile(files);
          files.results.forEach((file) => {
            this.setIsRemovable(file.id, file.creationUser);
          });
        }
      });
  }

  renderPaginatorFile(result: PagedList<any>) {
    this.uploadTotalItems = result.rowCount;
    this.uploadTotalPages = result.pageCount;
    this.uploadFirstItemOnPage = result.firstRowOnPage;
    this.uploadLastItemOnPage = result.lastRowOnPage;

    this.uploadCurrentPage = result.currentPage;

    this.uploadListedPages = [];

    let startPage = this.uploadCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.uploadCurrentPage + 2;
    while (maxPage > this.uploadTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.uploadListedPages.push(i);
    }

    if (!result.results.length) {
      this.uploadTotalPages = 1;
      this.uploadCurrentPage = 1;
      this.uploadFirstItemOnPage = 0;

      this.uploadListedPages = [];
      this.uploadListedPages.push(1);
    }
  }

  setIsRemovable(id: number, createUser: string) {
    return this.canRemove(createUser).then((res) => {
      this.roles = res;
      const isGestor = this.authService.authToken.isAccountManager;
      const myRoles = this.roles.filter((z) => (isGestor ? z === 2 : z === 10));
      const isRemovable = this.authService.hasRoles(myRoles);

      this.canDelete.push({ id, isRemovable });
      return Promise.resolve(res);
    });
  }

  async canRemove(createUser: string) {
    return await this.authService.rolesByUsername(createUser).toPromise();
  }

  createPrecedent(item) {
    this.service.StructuredOperations.createPrecedent(item).subscribe(
      (r) => {}
    );
  }

  isCreatorPrecedent(item): boolean {
    var auth = this.authService.getAuth();
    return item.creationPrecedent == auth.username;
  }

  download(name: string) {
    const download = this.fileService.download(name);

    return download.subscribe(
      (data: Blob) => {
        this.downloadService.downloadFile(data, name);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível fazer o download do arquivo.",
          "OK"
        );
      }
    );
  }

  openPdf(name: string) {
    var isPdf = name.includes(".pdf");

    const download = this.fileService.download(name);

    return download.subscribe((data: Blob) => {
      this.dialogService.modalFile(data, isPdf);
    });
  }

  isValidFile(fileName: String): boolean {
    return (
      fileName.includes(".pdf") ||
      fileName.includes(".jpeg") ||
      fileName.includes(".png") ||
      fileName.includes(".jpg")
    );
  }
}
